import React from 'react';
import Select from 'react-select';
import { fetchUsers } from 'api';

class UserSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value : undefined,
      options: []
    }
    this.getOptions = this.getOptions.bind(this);
  }
  getOptions(input, preload = null) {
    const value = this.props.multi ? this.props.value || [] : this.props.value || '';
    this.setState({ isLoading: true });
    const [ firstname, lastname ] = input.split(' ');
    return fetchUsers({
      size: 100,
      filters: {
        $or: [
        ...(this.props.multi? value.map(v => ({ _id: v })) : value ? [{ _id: value }] : []),
        ...(lastname ? [{['name.last']: { $regex: `${lastname}`, $options: 'gi' }}] : []),
        ...(firstname ? [{['name.first']: { $regex: `${firstname}`, $options: 'gi' }}] : []),
        ...([{['username']: { $regex: `${input}`, $options: 'gi' }}])
      ] }
    }).then(({ results }) => {
      if(!this.mounted) return;

      this.setState({ isLoading: false });
      this.setState({
        options : [
          ...results.map(
            user => ({
              label : user.name && (user.name.first || user.name.last) ? `${user.name.first} ${user.name.last}(${user.username})` : user.email,
              value : user._id
            })
          ),
          ...this.state.options.filter(i => !results.find(r => i._id == r._id)),
        ]
      });
    }).catch(error => {
      if(!this.mounted) return;
      this.setState({ isLoading: false, error });
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.getOptions('', this.props.value)
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    return (
      <Select
        onInputChange={this.getOptions}
        placeholder={this.props.placeholder || 'Find a User'}
        name="user-select"
        options={this.state.options}
        value={this.props.value || this.state.value}
        isLoading={this.state.isLoading}
        onChange={this.props.onChange}
        {...this.props}
      />
    )
  }
}

UserSelect.propTypes = {
  onChange : React.PropTypes.func.isRequired,
}

export default UserSelect;



// WEBPACK FOOTER //
// ./src/browser/components/users/user-select.js